import {
    SAVE_ATTRIBUTE_FORM_REQUEST,
    SAVE_ATTRIBUTE_FORM_ERROR,
    SAVE_ATTRIBUTE_FORM_SUCCESS,
    UPDATE_ATTRIBUTE_FORM_REQUEST,
    UPDATE_ATTRIBUTE_FORM_ERROR,
    UPDATE_ATTRIBUTE_FORM_SUCCESS,
    FETCH_ATTRIBUTE_FORM_ERROR,
    FETCH_ATTRIBUTE_FORM_REQUEST,
    FETCH_ATTRIBUTE_FORM_SUCCESS
  } from 'actionTypes'
  
  const DEFAULT_STATE = {
    get: {
      record: {
        resultList: []
      },
      error: null,
      isFetching: false,
    },
    save: {
      record: [],
      isUpdating: false,
      error: null,
    },
    update: {
      record: [],
      isUpdating: false,
      error: null
    }
  }
  
  const record = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
      
      case "RESET_ALL":
        return {
          ...DEFAULT_STATE
        }
      case FETCH_ATTRIBUTE_FORM_REQUEST:
        return {
          ...state,
          get: {
          ...state.get,
          isFetching: true,
          error: null,
          }
        }
  
      case FETCH_ATTRIBUTE_FORM_SUCCESS:
        return {
          ...state,
          get: {
            ...state.get,
            record: action.payload,
            isFetching: false,
            error: null,
          },
        }
  
      case FETCH_ATTRIBUTE_FORM_ERROR:
        return {
          ...state,
          get: {
            ...state.get,
            record: {},
            isFetching: false,
            error: action.payload,
          },
        }
  
      case SAVE_ATTRIBUTE_FORM_REQUEST:
        return {
          ...state,
          save: {
            ...state.save,
            record: null,
            error: null,
            isUpdating: true,
          },
        }
  
      case SAVE_ATTRIBUTE_FORM_SUCCESS:
        return {
          ...state,
          save: {
            ...state.save,
            record: action.payload,
            isUpdating: false,
            error: null
          },
          
        }

      case "SAVE_RESET":
        return {
          ...state,
          save: {
            record: null,
            isUpdating: false,
            error: null
          }
        }
  
      case SAVE_ATTRIBUTE_FORM_ERROR:
        return {
          ...state,
          save: {
            ...state.save,
            isUpdating: false,
            error: action.payload,
          },
        }

      case UPDATE_ATTRIBUTE_FORM_REQUEST: 
        return {
          ...state,
          update : {
            ...state.update,
            record: null,
            isUpdating: true,
            error: null
          }
        }

      case UPDATE_ATTRIBUTE_FORM_ERROR: 
        return {

          ...state,
          update : {
            ...state.update,
            isUpdating: false,
            error: action.payload
          }

        }

      case UPDATE_ATTRIBUTE_FORM_SUCCESS: 
        return {
          ...state,
          update : {
            ...state.update,
            record: action.payload,
            isUpdating: false,
            error: null
          }
          
        }
  
      default:
        return state
    }
  }
  
  export default record
  